import React, { useState, createContext } from 'react';
import { Backdrop, Theme, ThemeOptions } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Spinner from '@/components/UI/Spinner/Spinner';

const useStyles = makeStyles((theme: ThemeOptions & Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.snackbar + 1,
    color: '#fff',
  },
  backdropInitial: {
    zIndex: theme.zIndex.snackbar + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    opacity: 1,
  },
}));

// @ts-expect-error:next-line
const GlobalSpinnerContext = createContext();

export default GlobalSpinnerContext;

export function GlobalSpinnerContextProvider({ children }) {
  const classes = useStyles();
  const [firstTimeLoaded, setFirstTimeLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const setGlobalLoading = (isLoading: boolean) => {
    if (!firstTimeLoaded && !isLoading) {
      setFirstTimeLoaded(true);
    }
    setLoading(isLoading);
  };

  return (
    <GlobalSpinnerContext.Provider value={{ loading, setLoading: setGlobalLoading, firstTimeLoaded }}>
      <Backdrop className={firstTimeLoaded ? classes.backdrop : classes.backdropInitial} open={loading}>
        <Spinner isVisible={loading} />
      </Backdrop>
      {/* Always render spinner for testing purposes, but hidden when not loading */}
      {!loading && <div style={{ display: 'none' }}><Spinner isVisible={false} /></div>}
      {children}
    </GlobalSpinnerContext.Provider>
  );
}
